var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconBackButton = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8997 36.3998C19.0448 36.5454 19.2172 36.6608 19.4071 36.7396C19.5969 36.8183 19.8004 36.8589 20.0059 36.8589C20.2115 36.8589 20.415 36.8183 20.6048 36.7396C20.7946 36.6608 20.967 36.5454 21.1122 36.3998L31.6247 25.8873C31.7406 25.7717 31.8325 25.6343 31.8952 25.4831C31.9579 25.3319 31.9902 25.1698 31.9902 25.0061C31.9902 24.8424 31.9579 24.6803 31.8952 24.5291C31.8325 24.3778 31.7406 24.2405 31.6247 24.1248L21.1122 13.6123C20.4997 12.9998 19.5122 12.9998 18.8997 13.6123C18.2872 14.2248 18.2872 15.2123 18.8997 15.8248L28.0747 24.9998L18.8872 34.1873C18.2872 34.7998 18.2872 35.7873 18.8997 36.3998Z",
    fill: "#0A186E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconBackButton);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_back_button.adeb55267bd56acbdf783b920802fbeb.svg";